import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { ICaseStudy, ICaseStudyContent } from 'src/utils/Interfaces/caseStudies.interface'

const BASE_URL = import.meta.env.VITE_BASE_URL
const STUDY_URL = '/api/case-studies'

export const caseStudiesApi = createApi({
  reducerPath: 'caseStudiesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    credentials: 'include'
  }),
  tagTypes: ['CaseStudy', 'CaseStudies', 'BlogPosts', 'BlogPost'],
  endpoints: (build) => ({
    getCaseStudies: build.query<ICaseStudy[], void>({
      query: () => ({
        url: STUDY_URL
      }),
      providesTags: ['CaseStudies']
    }),
    getCaseStudy: build.query<ICaseStudy, number>({
      query: (id) => ({
        url: `${STUDY_URL}/${id}`
      }),
      providesTags: ['CaseStudy']
    }),
    getBlogPosts: build.query<ICaseStudy[], void>({
      query: () => ({
        url: `${STUDY_URL}/blog`
      }),
      providesTags: ['BlogPosts']
    }),
    createCaseStudy: build.mutation<ICaseStudy, void>({
      query: () => ({
        url: STUDY_URL,
        method: 'POST'
      }),
      invalidatesTags: ['CaseStudies']
    }),
    createBlogPost: build.mutation<ICaseStudy, void>({
      query: () => ({
        url: `${STUDY_URL}/blog`,
        method: 'POST'
      }),
      invalidatesTags: ['BlogPosts']
    }),
    updateCaseStudy: build.mutation<ICaseStudy, Partial<ICaseStudy>>({
      query: (body) => ({
        url: `${STUDY_URL}/${body.id}`,
        method: 'PATCH',
        body
      }),
      invalidatesTags: ['CaseStudy', 'CaseStudies']
    }),
    updateContent: build.mutation<ICaseStudyContent, Partial<ICaseStudyContent>>({
      query: (body) => ({
        url: `${STUDY_URL}/content/${body.id}`,
        method: 'PATCH',
        body
      }),
      invalidatesTags: ['CaseStudy']
    }),
    deleteCaseStudy: build.mutation<void, number>({
      query: (id) => ({
        url: `${STUDY_URL}/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['CaseStudy', 'CaseStudies', 'BlogPosts']
    })
  })
})

export const {
  useGetBlogPostsQuery,
  useGetCaseStudiesQuery,
  useGetCaseStudyQuery,
  useCreateCaseStudyMutation,
  useCreateBlogPostMutation,
  useUpdateCaseStudyMutation,
  useUpdateContentMutation,
  useDeleteCaseStudyMutation
} = caseStudiesApi
